const initReboltScript = () => {
  const reboltCards = document.querySelectorAll('.RB_Product_Card');
  const products = [];

  const getProductByHandle = async (handle) => {
    try {
      const response = await fetch(`/products/${handle}.js`);
      if (response.ok) {
        const product = await response.json();
        return product;
      }
    } catch (error) {
      console.error('エラー', error);
    }
    return null;
  };

  const getStockFromTags = (tags) => {
    const stockTag = tags.find(tag => tag.startsWith('在庫:'));
    if (stockTag) {
      const stockQuantity = parseInt(stockTag.split(':')[1]);
      return isNaN(stockQuantity) ? null : stockQuantity;
    }
    return null;
  };

  const getQuantityFromTitle = (titleText) => {
    const quantityMatch = titleText.match(/^(\d+)\s*×/);
    return quantityMatch ? parseInt(quantityMatch[1]) : 1;
  };

  const checkStockExceeded = (product, cartQuantity) => {
    const availableStock = getStockFromTags(product.tags);
    if (availableStock !== null && cartQuantity > availableStock) {
      return true;
    }
    return false;
  };
  
  const extractVariantInfo = () => {
    const variantInfo = [];
    
    reboltCards.forEach((card, index) => {
      const titleElement = card.querySelector('.RB_PC_Title a');
      const href = titleElement?.getAttribute('href');
      const handle = href ? href.replace('/products/', '') : null;
      const info = {
        handle: handle,
      };
      variantInfo.push(info);
    });
    return variantInfo;
  };

  const processReboltVariants = async () => {
    try {
      const variants = extractVariantInfo();
      
      if (variants.length === 0) {
        console.log('バリアントが見つかりません。');
        return;
      }
      
      for (const variant of variants) {
        if (variant.handle) {
          try {
            const productData = await getProductByHandle(variant.handle);
            if (productData) {
              products.push(productData);
            }
          } catch (error) {
            console.error('エラー', error);
          }
        }
      }


    } catch (error) {
      console.error('エラー', error);
    }
  };
  
  let observerTimeout;
  const observer = new MutationObserver(() => {
    clearTimeout(observerTimeout);
    observerTimeout = setTimeout(() => {
      const addToCartButton = document.querySelector('.RB_BuildBox_AddToCart');
      const addToCartButtonText = addToCartButton.querySelector('.RB_Button_text');
      const cartTitles = document.querySelectorAll('.RB_CC_Title');

      const activateAddToCartButton = () => {
        addToCartButton.style.pointerEvents = 'auto';
        addToCartButton.style.opacity = '1';
      }
      const deactivateAddToCartButton = () => {
        addToCartButton.style.pointerEvents = 'none';
        addToCartButton.style.opacity = '0.5';
      }

      const showOutOfStock = (outOfStockItems) => {
        removeOutOfStock();
        const addToCartButton = document.querySelector('.RB_BuildBox_AddToCart');
        if (!addToCartButton || outOfStockItems.length === 0) return;
        
        const outOfStockContainer = document.createElement('div');
        outOfStockContainer.className = 'rb-out-of-stock-warning';
        outOfStockContainer.style.cssText = `
          width: 100%;
          background-color: #fff3cd;
          border: 1px solid #ffeaa7;
          border-radius: 4px;
          padding: 10px;
          margin-bottom: 10px;
          font-size: 14px;
          color: #856404;
        `;
        
        const warningTitle = document.createElement('div');
        warningTitle.textContent = '以下の商品が在庫不足のため、予約購入となります。';
        warningTitle.style.cssText = `
          font-weight: bold;
          margin-bottom: 5px;
        `;
        outOfStockContainer.appendChild(warningTitle);
        
        const itemsList = document.createElement('ul');
        itemsList.style.cssText = `
          margin: 0;
          padding-left: 20px;
        `;
        
        outOfStockItems.forEach(item => {
          const listItem = document.createElement('li');
          listItem.textContent = `${item.title} (カート: ${item.cartQuantity}, 在庫: ${item.availableStock})`;
          itemsList.appendChild(listItem);
        });
        
        outOfStockContainer.appendChild(itemsList);
        addToCartButton.parentNode.insertBefore(outOfStockContainer, addToCartButton);
      }

      const removeOutOfStock = () => {
        const existingWarning = document.querySelector('.rb-out-of-stock-warning');
        if (existingWarning) {
          existingWarning.remove();
        }
      };

      if (cartTitles.length === 0) {
        addToCartButtonText.textContent = 'カートに追加';
        activateAddToCartButton();
        removeOutOfStock();
      } else {
        const outOfStockItems = [];
        let hasStockIssues = false;
        let hasPermanentOutOfStock = false;
        let hasZeroStock = false;
        let hasStockExceeded = false;
        
        cartTitles.forEach(cartTitle => {
          const originalTitleText = cartTitle.textContent.trim();
          const cartQuantity = getQuantityFromTitle(originalTitleText);
          const cleanTitleText = originalTitleText.replace(/^\d+\s*×\s*/, '');
          const product = products.find(p => p.title === cleanTitleText);
          if (product) {
            const stockExceeded = checkStockExceeded(product, cartQuantity);
            
            if (product.tags.includes('永久品切れ')) {
              hasPermanentOutOfStock = true;
            } else if (product.tags.includes('在庫:0')) {
              hasZeroStock = true;
            } else if (stockExceeded) {
              hasStockExceeded = true;
            }
            
            if (stockExceeded) {
              const availableStock = getStockFromTags(product.tags);
              outOfStockItems.push({
                title: cleanTitleText,
                cartQuantity: cartQuantity,
                availableStock: availableStock
              });
              hasStockIssues = true;
            }
          }
        });
        
        if (addToCartButtonText) {
          if (hasPermanentOutOfStock) {
            addToCartButtonText.textContent = '品切れ';
            deactivateAddToCartButton();
          } else if (hasZeroStock || hasStockExceeded) {
            addToCartButtonText.textContent = '予約購入';
            activateAddToCartButton();
          } else {
            addToCartButtonText.textContent = 'カートに追加';
            activateAddToCartButton();
          }
        }
        
        if (hasStockIssues && outOfStockItems.length > 0 && !hasPermanentOutOfStock) {
          showOutOfStock(outOfStockItems);
        } else {
          removeOutOfStock();
        }
      }
      
    }, 200);
  });

  const buildBoxInfo = document.querySelector('.RB_BuildBoxInfo');
  if (buildBoxInfo) {
    observer.observe(buildBoxInfo, {
      childList: true,
      subtree: true
    });
  }

  if(reboltCards.length > 0) {
    processReboltVariants();
  }
}


const waitForRebolt = () => {
  const targetSelector = '.RB_Product_Card';
  const timeout = 20000; // 20 seconds timeout
  
  if (document.querySelector(targetSelector)) {
    initReboltScript();
    return;
  }
  
  let timeoutId;
  let observer;
  
  timeoutId = setTimeout(() => {
    if (observer) {
      observer.disconnect();
    }
  }, timeout);
  
  observer = new MutationObserver((mutations) => {
    if (document.querySelector(targetSelector)) {
      clearTimeout(timeoutId);
      observer.disconnect();
      initReboltScript();
    }
  });
  
  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', waitForRebolt);
} else {
  waitForRebolt();
}